import React, { useState } from 'react'
import Logo from '../assets/imgs/bodewrk-logo.png'
import { makeStyles } from '@mui/styles'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import ProfilePicture from '../assets/imgs/profile-picture.png'
import NotificationsIcon from '../assets/imgs/notifications-icon.svg'
import MessagesIcon from '../assets/imgs/messages-icon.svg'
import UserImagePlaceholder from '../assets/imgs/user-image-placeholder.png'
import NotificationModal from '../modals/NotificationModal'
import { Box, Drawer } from '@mui/material'
import MenuIcon from '../assets/imgs/menu-icon.svg'
import SwitchAccountIcon from '@mui/icons-material/SwitchAccount'
import { useSelector } from 'react-redux'
import { selectUser, setUser } from '../app/features/user/userSlice'
import { useDispatch } from 'react-redux'
import { switchProfile } from '../apis/userApis'
import { ScaleLoader } from 'react-spinners'

const useStyles = makeStyles({
  navigation: {
    background: '#FFFFFF',
  },
  navLinks: {
    display: 'flex',
    padding: 0,
    marging: 0,
    listStyle: 'none',
    margin: 0,
  },
  link: {
    opacity: 1,
    margin: '0 10px',
    textAlign: 'center',
    textDecoration: 'none',
    color: '',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  activeLink: {
    borderBottom: '2px solid #111111',
    fontWeight: 'bold',
  },
  navWrapper: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  activeDrawerLink: {
    borderRadius: '20px',
    background: `transparent
    linear-gradient(180deg, #01ced1 0%, #14b1e4 44%, #2992fb 100%)`,
    color: '#fff',
  },
  drawerLink: {
    borderRadius: '20px',
    border: `1px solid #08c4bb`,
    color: '#08c4bb',
  },
})

function HomeNav() {
  const classes = useStyles()
  const location = useLocation()
  const navigate = useNavigate()
  const user = JSON.parse(localStorage.getItem('user'))
  const dispatch = useDispatch()
  const [notificationModal, setNotificationModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const hanldeNotificationModal = (toggleModal) => {
    setNotificationModal(toggleModal)
  }

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  })

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return
    }

    setState({ ...state, [anchor]: open })
  }

  const switchUserProfile = async () => {
    let body = {
      user_id: user?.id,
    }
    setIsLoading(true)
    if (user?.user_type === 'client') {
      body.user_type = 'provider'
      let result = await switchProfile('update-user-type', body)
      setIsLoading(false)
      if (result?.success === true && result?.data != null) {
        localStorage.setItem('user', JSON.stringify(result?.data))
        dispatch(setUser({ user: result?.data }))
        navigate('/dashboard')
      }
    } else if (user?.user_type === 'provider') {
      body.user_type = 'client'
      let result = await switchProfile('update-user-type', body)
      setIsLoading(false)
      if (result?.success === true && result?.data != null) {
        localStorage.setItem('user', JSON.stringify(result?.data))
        dispatch(setUser({ user: result?.data }))
        navigate('/home')
      }
    }
  }

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div className="p-4">
        <Link to={'/dashboard'} className="text-decoration-none">
          <div
            className={`py-2 px-3 pointer ${
              location.pathname === '/dashboard'
                ? classes.activeDrawerLink
                : classes.drawerLink
            }`}
          >
            <p className="fs-18 fw-bold">Home</p>
          </div>
        </Link>
        <Link to={'/client-search'} className="text-decoration-none">
          <div
            className={`py-2 px-3 pointer mt-2 ${
              location.pathname === '/client-search'
                ? classes.activeDrawerLink
                : classes.drawerLink
            }`}
          >
            <p className="fs-18 fw-bold">Search</p>
          </div>
        </Link>
        <Link to={'/services'} className="text-decoration-none">
          <div
            className={`py-2 px-3 pointer mt-2 ${
              location.pathname === '/styles'
                ? classes.activeDrawerLink
                : classes.drawerLink
            }`}
          >
            <p className="fs-18 fw-bold">Styles</p>
          </div>
        </Link>
        <Link to={'/stylers'} className="text-decoration-none">
          <div
            className={`py-2 px-3 pointer mt-2 ${
              location.pathname === '/stylers'
                ? classes.activeDrawerLink
                : classes.drawerLink
            }`}
          >
            <p className="fs-18 fw-bold">Stylers</p>
          </div>
        </Link>
        <Link to={'/profile'} className="text-decoration-none">
          <div
            className={`py-2 px-3 pointer mt-2 ${
              location.pathname === '/profile'
                ? classes.activeDrawerLink
                : classes.drawerLink
            }`}
          >
            <p className="fs-18 fw-bold">Profile</p>
          </div>
        </Link>
        <div
          className={`py-2 px-3 pointer mt-2 ${classes.drawerLink}`}
          onClick={hanldeNotificationModal}
        >
          <p className="fs-18 fw-bold">Notifications</p>
        </div>
        <Link
          to={'/chat'}
          className="text-decoration-none"
          style={{ marginRight: '1.3rem' }}
        >
          <div
            className={`py-2 px-3 pointer mt-2 ${
              location.pathname === '/chat'
                ? classes.activeDrawerLink
                : classes.drawerLink
            }`}
          >
            <p className="fs-18 fw-bold">Chat</p>
          </div>
        </Link>
      </div>
    </Box>
  )

  return (
    <>
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100vh',
          top: 0,
          display: 'flex',
          zIndex: 9,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <div className="container">
        <div className="row">
          <div className="nav-wrapper">
            <div className="d-flex align-items-center loginNavWrapper justify-content-between">
              <div className="d-flex align-items-center justify-content-sm-center">
                <Link to={'/dashboard'}>
                  <img
                    src={Logo}
                    alt="Bod-E-Woek Logo"
                    width={99}
                    height={58}
                  />
                </Link>
                <h3 className="logo-text d-inline-block m-0 text-black font-weight-bold">
                  BODEWRK
                </h3>
              </div>
              <div className="d-block d-lg-none">
                <img
                  src={MenuIcon}
                  alt="Menu Icon"
                  onClick={toggleDrawer('left', true)}
                  sx={{ fontSize: '2rem' }}
                  className="pointer"
                />
                <Drawer
                  anchor={'left'}
                  open={state['left']}
                  onClose={toggleDrawer('left', false)}
                >
                  {list('left')}
                </Drawer>
              </div>
              <div className={`${classes.navLinks}`} id="login-nav-links">
                <div>
                  <NavLink
                    className={({ isActive }) =>
                      isActive
                        ? classes.activeLink + ' link font-weight-bold'
                        : 'link'
                    }
                    to="/dashboard"
                  >
                    <p className="nav-link m-0">Home</p>
                  </NavLink>
                </div>
                <div>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? classes.activeLink + ' link' : 'link'
                    }
                    to="/search"
                  >
                    <p className="nav-link m-0">Search</p>
                  </NavLink>
                </div>
                <div>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? classes.activeLink + ' link' : 'link'
                    }
                    to="/styles"
                  >
                    <p className="nav-link m-0">Styles</p>
                  </NavLink>
                </div>
                <div>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? classes.activeLink + ' link' : 'link'
                    }
                    to="/availability"
                  >
                    <p className="nav-link m-0">Availability</p>
                  </NavLink>
                </div>
                <div>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? classes.activeLink + ' link' : 'link'
                    }
                    to="/my-business"
                  >
                    <p className="nav-link m-0">My Business</p>
                  </NavLink>
                </div>
                <div className="mx-1">
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? classes.activeLink + ' link' : 'link'
                    }
                    to={'/profile'}
                  >
                    {user?.profile_image && (
                      <img
                        src={user?.profile_image}
                        height={37}
                        width={37}
                        style={{ borderRadius: '50%', objectFit: 'cover' }}
                      />
                    )}
                    {!user?.profile_image && (
                      <img
                        src={UserImagePlaceholder}
                        height={37}
                        width={37}
                        style={{ borderRadius: '50%', objectFit: 'cover' }}
                      />
                    )}
                  </NavLink>
                </div>
                <div className="d-flex align-items-center pointer mx-1">
                  <img
                    src={NotificationsIcon}
                    alt="Notification Icon"
                    height={25}
                    className="mb-1"
                    onClick={hanldeNotificationModal}
                  />
                </div>
                <div>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? classes.activeLink + ' link' : 'link'
                    }
                    to="/chat"
                  >
                    <img src={MessagesIcon} alt="Chat Icon" height={25} />
                  </NavLink>
                </div>
                <div className="d-flex align-items-center pointer mx-2">
                  <SwitchAccountIcon
                    sx={{ color: '#000', fontSize: '1.6rem' }}
                    onClick={switchUserProfile}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {notificationModal && (
        <NotificationModal
          hanldeNotificationModal={hanldeNotificationModal}
          modalOpen={notificationModal}
        ></NotificationModal>
      )}
    </>
  )
}

export default HomeNav
